import { Grid, LinearProgress } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'
import UserCreateModal from '../../components/UserCreateModal'
import Context from '../../context'
import { getSearch, getUsersList } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function UsersPage() {
  const { setUser, setOpenToast, setAboutCurrentPage } = useContext(Context)

  const [fullUsersList, setFullUsersList] = useState([])
  const [filter, setFilter] = useState(0)
  const [usersList, setUsersList] = useState([])
  const [tempUsersList, setTempUsersList] = useState([])
  const [isFiltered, setIsFiltered] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [partnerStr, setPartnerStr] = useState('')
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [objectData, setObjectData] = useState({
    name: '',
    password: '',
    office: '',
    userGroup: ''
  })

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Usuários'
      // buttons: [{ title: 'Adicionar Usuário', pathname: '/muralform' }],
    })
    getUsersList().then(r => {
      if (r) {
        setUsersList(r)
        setFullUsersList(r)
        setIsLoading(false)
      } else {
        console.log({ error: r })
      }
    })
  }, [])

  useEffect(() => {
    console.log(usersList)
  }, [usersList])

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('users', searchData.str).then(r => {
        if (r) {
          console.log('aquii', r)
          setUsersList(r)
          setSearchData({ ...searchData, startSearch: false })
        } else {
          setUsersList([])
        }
        setIsLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setUsersList(fullUsersList)
    }
  }, [searchData])

  const handleEditButton = id => {
    const userToEdit = usersList
      .map(item => {
        return {
          ...item,
          userGroup: `${item.UserGroup.id}`
        }
      })
      .find(item => id === item.id)

    if (userToEdit.Partner) {
      setPartnerStr(userToEdit.Partner.fantasyName)
    } else {
      setPartnerStr('')
    }

    setObjectData(userToEdit)
  }

  const handleFilterAction = groupId => {
    const listToFilter = isFiltered ? tempUsersList : fullUsersList
    if (groupId > 0) {
      setUsersList(
        listToFilter.filter(item => {
          return item.UserGroup.id === Number(groupId)
        })
      )
    } else {
      setUsersList(fullUsersList)
    }
    setFilter(Number(groupId))
  }

  return (
    <div className="container-fluid h-100">
      <Grid container xs={12} style={{ padding: 15 }}>
        <Grid item xs={12} justify="center">
          <ToastMessages />
        </Grid>

        {isLoading ? (
          <Grid item xs={12} justify="center">
            <LinearProgress marginTop="30px" />
          </Grid>
        ) : (
          <Grid item xs={12} justify="center">
            <Context.Provider value={{ searchData, setSearchData }}>
              <TopSearch
                searchAction={() => {}}
                filterAction={handleFilterAction}
                showUserFilter
                showAddUserButton
              />
            </Context.Provider>
            <h3>Usuários</h3>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Nome</th>
                  <th scope="col">E-mail</th>
                  <th scope="col">Cargo</th>
                  <th scope="col">Grupo</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody>
                {usersList.map(item => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.office}</td>
                    <td>{item.UserGroup.name}</td>
                    <td className="d-flex flex-row">
                      <div style={{ padding: '2px' }}>
                        <button
                          type="button"
                          onClick={() => handleEditButton(item.id)}
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#userCreateModal"
                        >
                          Editar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Grid>
        )}
        <Grid item xs={12} justify="center">
          <Context.Provider
            value={{
              objectData,
              setObjectData,
              setOpenToast,
              partnerStr,
              setPartnerStr
            }}
          >
            <UserCreateModal />
          </Context.Provider>
        </Grid>
      </Grid>
    </div>
  )
}

export default UsersPage
